import { useEffect, useState } from 'react'
import { db } from '../../../firebase'
import {
  collection,
  onSnapshot,
  query,
  orderBy,
  doc,
  updateDoc,
  deleteDoc,
} from 'firebase/firestore'

import './studentsAdmin.css'

export default function StudentsList() {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [editing, setEditing] = useState({})

  useEffect(() => {
    const q = query(collection(db, 'users'), orderBy('createdAt', 'desc'))

    const unsubscribe = onSnapshot(q, (snapshot) => {
      setUsers(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })))
      setLoading(false)
    })

    return () => unsubscribe()
  }, [])

  if (loading) return <p>Загрузка пользователей...</p>
  if (users.length === 0) return <p>Пользователи пока не добавлены</p>

  const toggleActive = async (id, current) => {
    await updateDoc(doc(db, 'users', id), { active: !current })
  }

  const changeRole = async (id, role) => {
    await updateDoc(doc(db, 'users', id), { role })
  }

  const removeUser = async (id) => {
    if (window.confirm('Удалить пользователя?')) {
      await deleteDoc(doc(db, 'users', id))
    }
  }

  const startEdit = (id, field, value) => {
    setEditing({ id, field, value })
  }

  const saveEdit = async (id) => {
    if (editing.field && editing.value !== undefined) {
      await updateDoc(doc(db, 'users', id), {
        [editing.field]: editing.value,
      })
    }
    setEditing({})
  }

  const filteredUsers = users.filter(
    (u) =>
      u.name?.toLowerCase().includes(search.toLowerCase()) ||
      u.email?.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <div>
      <h2>Список пользователей</h2>

      <input
        type="text"
        placeholder="Поиск по имени или email"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <table className="user-list-container">
        <thead className="title">
          <tr>
            <th>Имя</th>
            <th>Email</th>
            <th>Роль</th>
            <th>Активен</th>
            <th>Действия</th>
          </tr>
        </thead>

        <tbody className="user-table">
          {filteredUsers.map((user) => (
            <tr key={user.id}>
              <td>
                {editing.id === user.id && editing.field === 'name' ? (
                  <>
                    <input
                      value={editing.value}
                      onChange={(e) => setEditing({ ...editing, value: e.target.value })}
                    />
                    <button onClick={() => saveEdit(user.id)}>Сохранить</button>
                    <button onClick={() => setEditing({})}>Отмена</button>
                  </>
                ) : (
                  <span onDoubleClick={() => startEdit(user.id, 'name', user.name)}>
                    {user.name}
                  </span>
                )}
              </td>

              <td>
                {editing.id === user.id && editing.field === 'email' ? (
                  <>
                    <input
                      value={editing.value}
                      onChange={(e) => setEditing({ ...editing, value: e.target.value })}
                    />
                    <button onClick={() => saveEdit(user.id)}>Сохранить</button>
                    <button onClick={() => setEditing({})}>Отмена</button>
                  </>
                ) : (
                  <span onDoubleClick={() => startEdit(user.id, 'email', user.email)}>
                    {user.email}
                  </span>
                )}
              </td>

              <td>
                <select value={user.role} onChange={(e) => changeRole(user.id, e.target.value)}>
                  <option value="student">Студент</option>
                  <option value="admin">Админ</option>
                </select>
              </td>

              <td>
                <input
                  type="checkbox"
                  checked={user.active}
                  onChange={() => toggleActive(user.id, user.active)}
                />
              </td>

              <td>
                <button className="btn-delete" onClick={() => removeUser(user.id)}>
                  Удалить
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
